import React from 'react';

import Summary from '../Summary';
import SummaryTrials from '../SummaryTrials';
import SummaryStudents from '../SummaryStudents';
import SummaryHoliday from '../SummaryHoliday/SummaryHoliday';
import { useCheckoutContext } from '../../state/CheckoutContext';

const SummaryContainer = () => {
  const { checkoutEntityState } = useCheckoutContext();

  const {
    isTrial,
    isStudentPromotion,
    isHolidayPromotion
  } = checkoutEntityState;

  if (isStudentPromotion) {
    return <SummaryStudents />;
  }
  if (isHolidayPromotion) {
    return <SummaryHoliday />;
  }
  if (isTrial) {
    return <SummaryTrials />;
  }
  return <Summary />;
};

export default SummaryContainer;
